import React, { useContext, useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import './style.css';
import { TooltipHost } from '@fluentui/react';
import BoardToolBarList from '../../../BoardBox/BoardList/BoardToolBarList';
import { useSetFirstLoadSelectedContainerId } from '../../../BoardBox/BoardList/useOfBoardList';
import { useSelector } from 'react-redux';
import { enum__KPIAgregationTypes } from '../../../../../../../common/Dictionaries';
import MainAppContext from '../../../../../../../MainAppContext';
import { isNullUndefined } from '../../../../../../../common/Helpers';

function ListSimpleGrouped(props) {
    const { t, i18n } = useTranslation();
    const contextSite = useContext(MainAppContext);

    const { 
        inputParam_UserPropsKpi = null,
        inputParam_Index = null,
        inputParam_Dataserie = null,
        inputParam_ItemFields = null,
        inputParam_DataserieList = null,
        inputParam_ElementId = null,
        inputParam_ElementList = null,
        inputParam_ContainerComponent = null,
        inputParam_BoardId= null,
        inputParam_FieldCount = 0,
        setBoardVariableDataserieValues= null,
        inputParam_HidePanels=false
    } = props;

    const variableName = `${inputParam_Dataserie.variableName}`

    const [colsToShow, setColsToShow] = useState(inputParam_ItemFields.length);

    useEffect(() => {
        function handleResize() {
            const minWidthForColumn = 492;

            if (window.innerWidth < minWidthForColumn) {
                setColsToShow(2);
            } else if (window.innerWidth >= 1940) {
                setColsToShow(inputParam_ItemFields.length);
            } else if (window.innerWidth >= 1770) {
                setColsToShow(7);
            } else if (window.innerWidth >= 1600) {
                setColsToShow(6);
            } else if (window.innerWidth >= 1430) {
                setColsToShow(5);
            } else if (window.innerWidth >= 1255) {
                setColsToShow(4);
            } else if (window.innerWidth >= 1200) {
                setColsToShow(3);
            } else if (window.innerWidth >= 980) {
                setColsToShow(inputParam_ItemFields.length);
            } else if (window.innerWidth >= 802) {
                setColsToShow(6); 
            } else if (window.innerWidth >= 700) {
                setColsToShow(5); 
            } else if (window.innerWidth >= 650) {
                setColsToShow(4);
            } else if (window.innerWidth >= 600) {
                setColsToShow(3);
            } else if (window.innerWidth >= 492) {
                setColsToShow(2);
            } else {
                setColsToShow(2);
            }
        }
  
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [inputParam_ItemFields.length]);

    return (<>
                <Row data-dataserie-id={inputParam_Dataserie.dataSerieId} className="d-flex mx-0 border w-100">
                    <Col className='w-100'>
                        <Row>
                            <Col className={`border-start border-end w-auto px-0 overflow-hidden`} style={{maxWidth: (inputParam_FieldCount - 4 === 1 ? '220px' : undefined) }}>
                                {
                                    (inputParam_Index === 0) &&
                                    <div style={{fontSize: "1rem"}} className="border-bottom">
                                        <Col className="text-center"><b style={{fontSize: "14px"}}>{ t(`data-lang-lbl-name`) }</b></Col>
                                    </div>
                                }
                                <div style={{maxWidth: inputParam_HidePanels ? "455px" : "133px", fontSize: "12px", borderLeft: `10px solid ${inputParam_ElementList !== null ? inputParam_ElementList.find(x => x.elementId === inputParam_Dataserie.elementId).htmlColor : ''}`}} className={`my-1 px-0 ps-1`}>
                                    <TooltipHost content={variableName}>
                                        <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                            {variableName}
                                        </div>
                                    </TooltipHost>
                                    <div>{`(${inputParam_Dataserie.um})`}</div>
                                </div>
                            </Col>
                            {
                                inputParam_ItemFields && inputParam_ItemFields.map((field, index) => (
                                    <Col style={{minWidth: (index === 0) ? "100px" : "90px"}} className={
                                        `col-auto border-start border-end px-0 ${(inputParam_ItemFields.length !== index)? "px-0" : "ps-2" }`
                                        } key={index}>
                                        {
                                            (inputParam_Index === 0) &&
                                            <div style={{fontSize: "1rem"}} className="border-bottom">
                                                <Col className="text-center"><b style={{fontSize: "14px"}}>{ t(`data-lang-lbl-field-${field}`) }</b></Col>
                                            </div>
                                        }
                                        {
                                            contextSite.kpiModule.boardCalendarFilterConfig.value.displayAgregationId === enum__KPIAgregationTypes.NO_AGG && 
                                            <>
                                                {
                                                    inputParam_Dataserie.l_vals.map((val, index) => (
                                                        <div style={{fontSize: "12px"}} key={index} className={`${(index !== inputParam_Dataserie.l_vals.length -1) ? 'border-bottom' : ''} my-1 pe-1 ${field.toLowerCase().indexOf('percent') !== -1 || field.toLowerCase().indexOf('time') !== -1 ? "text-center" : "text-end" } ${field.toLowerCase() === 'valuereal' || field.toLowerCase() === 'displayvalue' ? "variable-text-color-" + val.color : "variable-value-color" } ${field.toLowerCase().indexOf('percent') !== -1 ? "variable-value-color-" + val.color : "" } `}>
                                                            {          
                                                                field === "serieTime" &&
                                                                <>
                                                                    {val["serieTimeStr"] !== null ? val["serieTimeStr"].toString() : val["serieTime"]}
                                                                </>
                                                            }
                                                            {
                                                                field !== "serieTime" &&
                                                                <>
                                                                    {`${val[field] !== undefined && val[field] !== null && !isNaN(val[field]) ? (field !== 'serieTime' ? parseFloat(val[field]).toLocaleString(i18n.language) : val[field])  : t('no-data')}`}
                                                                    {`${field.toLowerCase().indexOf('percent') !== -1 ? " %" : ""}`}
                                                                </>
                                                            }
                                                        </div>
                                                    ))
                                                }
                                                {
                                                    inputParam_Dataserie.l_vals.length === 0 && 
                                                        <div style={{fontSize: "12px"}} className={`my-1 px-1 ${field.toLowerCase().indexOf('percent') !== -1 || field.toLowerCase().indexOf('time') !== -1 ? "text-center" : "text-end" } ${field.toLowerCase() === 'valuereal' || field.toLowerCase() === 'displayvalue' ? "variable-value-color" : "variable-value-color" } ${field.toLowerCase().indexOf('percent') !== -1 ? "variable-value-color" : "" } `}>{t('no-data')}</div>
                                                }
                                            </>
                                        }
                                        {
                                            contextSite.kpiModule.boardCalendarFilterConfig.value.displayAgregationId === enum__KPIAgregationTypes.DF_AGG && 
                                            <>
                                                {
                                                    (!isNullUndefined(inputParam_Dataserie.l_agg_vals) ? inputParam_Dataserie.l_agg_vals : inputParam_Dataserie.l_vals).map((val, index) => (
                                                        <div style={{fontSize: "12px"}} key={index} className={`${(index !== (!isNullUndefined(inputParam_Dataserie.l_agg_vals) ? inputParam_Dataserie.l_agg_vals : inputParam_Dataserie.l_vals).length -1) ? 'border-bottom' : ''} my-1 pe-1 ${field.toLowerCase().indexOf('percent') !== -1 || field.toLowerCase().indexOf('time') !== -1 ? "text-center" : "text-end" } ${field.toLowerCase() === 'valuereal' || field.toLowerCase() === 'displayvalue' ? "variable-text-color-" + val.color : "variable-value-color" } ${field.toLowerCase().indexOf('percent') !== -1 ? "variable-value-color-" + val.color : "" } `}>
                                                            {          
                                                                field === "serieTime" &&
                                                                <>
                                                                    {val["serieTimeStr"] !== null ? val["serieTimeStr"].toString() : val["serieTime"]}
                                                                </>
                                                            }
                                                            {
                                                                field !== "serieTime" &&
                                                                <>
                                                                    {`${val[field] !== undefined && val[field] !== null && !isNaN(val[field]) ? (field !== 'serieTime' ? parseFloat(val[field]).toLocaleString(i18n.language) : val[field])  : t('no-data')}`}
                                                                    {`${field.toLowerCase().indexOf('percent') !== -1 ? " %" : ""}`}
                                                                </>
                                                            }
                                                        </div>
                                                    ))
                                                }
                                                {
                                                    (!isNullUndefined(inputParam_Dataserie.l_agg_vals) ? inputParam_Dataserie.l_agg_vals : inputParam_Dataserie.l_vals).length === 0 && 
                                                        <div style={{fontSize: "12px"}} className={`my-1 px-1 ${field.toLowerCase().indexOf('percent') !== -1 || field.toLowerCase().indexOf('time') !== -1 ? "text-center" : "text-end" } ${field.toLowerCase() === 'valuereal' || field.toLowerCase() === 'displayvalue' ? "variable-value-color" : "variable-value-color" } ${field.toLowerCase().indexOf('percent') !== -1 ? "variable-value-color" : "" } `}>{t('no-data')}</div>
                                                }
                                            </>
                                        }
                                    </Col>
                                ))
                            }
                        </Row>
                    </Col>
                    <Col className='col-auto ms-auto' style={{
                        position: 'sticky',
                        right: -4,
                        backgroundColor: 'white',
                        zIndex: '1',
                    }}>
                        <Row>
                            {
                                inputParam_ContainerComponent && inputParam_DataserieList && !inputParam_HidePanels &&
                                <BoardToolBarList
                                    inputParam_UserPropsKpi={inputParam_UserPropsKpi}
                                    inputParam_BoardId={inputParam_BoardId}
                                    inputParam_ElementId={inputParam_ElementId}
                                    inputParam_DataserieList={inputParam_DataserieList}
                                    inputParam_Dataserie={inputParam_Dataserie}
                                    setBoardVariableDataserieValues={setBoardVariableDataserieValues}
                                    inputParam_ContainerComponent={inputParam_ContainerComponent}
                                    index={inputParam_Index}
                                />
                            }
                        </Row>
                    </Col>
                </Row>
                </>
      );
}

ListSimpleGrouped.propTypes = {
    inputParam_Dataserie: PropTypes.object.isRequired,
    inputParam_ItemFields: PropTypes.array.isRequired,
    inputParam_DataserieList: PropTypes.object.isRequired,
    inputParam_ElementList: PropTypes.array.isRequired,
    inputParam_Index: PropTypes.number.isRequired,
};

export default ListSimpleGrouped;